module.exports = __webpack_public_path__ + "static/Logo_w_text_white-4a1dbc2da9b11467c1174f0af85c8e50.png";